import { showNativeAlert } from "@payment-client/utils/Native";
import { Some, Option, None } from "@swiggy-private/js-fp";
import { OOPS_SOMETHING_WENT_WRONG } from "@payment-client/constants/TextDict";
// utils
import { isAbortError, isNetworkError } from "@swiggy-private/core-ui";
import { isPlainObject } from "@swiggy-private/js-utils";
import { ApiResponse } from "@payment-client/interfaces/Api";

export function isApiResponse<T>(response: unknown): response is ApiResponse<T> {
    return isPlainObject(response) && "statusCode" in response;
}

export function showApiError(err: unknown): void {
    let message: Option<string> = None;
    let title: Option<string> = None;

    if (isApiResponse(err)) {
        message = Some(err.statusMessage || null);
        title = Some(err.statusTitle);
    } else if (isNetworkError(err)) {
        title = Some("CONNECTION ERROR");
        message = Some("Please check your network connectivity and try again");
    } else if (isAbortError(err)) {
        title = Some("ABORT ERROR");
        message = Some("The request could not be processed completely, please check your network and try again");
    }

    showNativeAlert({
        message: message.unwrapOr(OOPS_SOMETHING_WENT_WRONG),
        title: title.unwrapOr(" "),
    });
}

let nativeNetworkErrorAlertVisible = false;

export function showNetworkError(err: unknown): void {
    if (!isNetworkError(err) || nativeNetworkErrorAlertVisible) {
        return;
    }

    nativeNetworkErrorAlertVisible = true;
    showNativeAlert({
        title: "CONNECTION ERROR",
        message: "Please check your network connectivity and try again",
    })
        .then(_res => {
            nativeNetworkErrorAlertVisible = false;
        })
        .catch(_err => {
            nativeNetworkErrorAlertVisible = false;
        });
}
